import ApiService from "@/api/baseApi/api-service";
import {
  IGEtPickupMethods,
  IGetShippingMethods,
} from "./interfaces/delevery-management-interfaces";
import { Config } from "../../config";
import {
  ICartManageItemParams,
  IGetCart,
  IGetDeliveryBranches,
  IGetPaymentMethods,
  IPaymentResponse,
  IPostPaymentMethodAvailableResult,
  ISetPaymentMethodParams,
  ISubmitCheckoutResponse,
  PostPaymentMethodAvailable,
} from "./interfaces/cart-interfaces";
import axios from "axios";
import { UserLocation } from "./user-location-interface";
const paymentURL = "/payments/";
const subBaseURL = "/carts";
const URLs = {
  getCart: subBaseURL,
  clearCart: subBaseURL + "/clear",
  postAddItem: subBaseURL + "/items",
  putEditItem: subBaseURL + "/items/",
  deleteItem: subBaseURL + "/items/",
  getShippingMethods: subBaseURL + "/shipping-methods?area_id=",
  getPickupMethods: subBaseURL + "/pickup-methods",
  setShippingMethods: subBaseURL + "/shipping-methods",
  setPaymentMethods: subBaseURL + "/payment-methods",
  postCoupons: subBaseURL + "/coupons",
  deleteCoupons: subBaseURL + "/coupons",
  submitCheckout: subBaseURL + "/submit",
  getPaymentMethods: subBaseURL + "/payment-methods",
  getDeliveryBranches: "/delivery-branches",
  postPaymentMethodAvailable: subBaseURL + "/payment-method-available",

  refresh: subBaseURL + "/refresh",
};
class ApiCart extends ApiService {
  constructor(config: Config) {
    super({ ...config });
    this.headers = { ...config };
  }
  headers: Config;
  getCart = (): Promise<IGetCart> => {
    return this.get(URLs.getCart, {});
  };
  clearCart = (): Promise<IGetCart> => this.delete(URLs.clearCart, {});
  manageCartItem = (body: ICartManageItemParams): Promise<IGetCart> => {
    const { cartId, fbc, fbp, fb_login_id, event_id, ttp, ttclid, twclid } =
      body;
    delete body.cartId;
    delete (body as any).fbc;
    delete (body as any).fbp;
    delete (body as any).fb_login_id;
    delete (body as any).event_id;
    delete (body as any).ttp;
    delete (body as any).ttclid;
    delete (body as any).twclid;
    const params: Record<string, any> = {};
    if (fbc) params.fbc = fbc;
    if (fbp) params.fbp = fbp;
    if (fb_login_id) params.fb_login_id = fb_login_id;
    if (event_id) params.event_id = event_id;
    if (ttp) params.ttp = ttp;
    if (ttclid) params.ttclid = ttclid;
    if (twclid) params.twclid = twclid;
    if (cartId)
      return this.put(
        URLs.putEditItem + cartId,
        { ...body },
        {
          params,
        },
      );
    else
      return this.post(
        URLs.postAddItem,
        { ...body },
        {
          params,
        },
      );
  };
  removeCartItem = (id: number): Promise<IGetCart> =>
    this.delete(URLs.deleteItem + id, {});
  getShippingMethods = (areaId: string): Promise<IGetShippingMethods> =>
    this.get(URLs.getShippingMethods + areaId, {});
  getpickupMethods = (): Promise<IGEtPickupMethods> =>
    this.get(URLs.getPickupMethods, {});
  setShippingMethod = ({
    price_zone_id,
    shipping_method_id,
    event_id,
    fbc,
    fbp,
    ttp,
    ttclid,
    twclid,
    fb_login_id,
  }: {
    price_zone_id: number;
    shipping_method_id: number;
    event_id?: string;
    fbc?: string;
    fbp?: string;
    ttp?: string;
    ttclid?: string;
    twclid?: string;
    fb_login_id?: string;
  }): Promise<IGetCart> =>
    this.post(
      URLs.setShippingMethods,
      {
        price_zone_id: price_zone_id,
        shipping_method_id: shipping_method_id,
      },
      {
        params: {
          event_id,
          fbc,
          fbp,
          ttp,
          ttclid,
          twclid,
          fb_login_id,
        },
      },
    );

  setPaymentMethod = (params: ISetPaymentMethodParams): Promise<IGetCart> => {
    const {
      event_id,
      fb_login_id,
      fbc,
      fbp,
      ttp,
      ttclid,
      twclid,
      delivery_type,
      ...rest
    } = params;
    const paramsObj: Record<string, any> = {};
    if (event_id) paramsObj.event_id = event_id;
    if (fb_login_id) paramsObj.fb_login_id = fb_login_id;
    if (fbc) paramsObj.fbc = fbc;
    if (fbp) paramsObj.fbp = fbp;
    if (ttp) paramsObj.ttp = ttp;
    if (ttclid) paramsObj.ttclid = ttclid;
    if (twclid) paramsObj.twclid = twclid;
    if (delivery_type) paramsObj.delivery_type = delivery_type;
    return this.post(
      URLs.setPaymentMethods,
      { ...rest },
      {
        params: paramsObj,
      },
    );
  };
  postCoupons = ({
    code,
    country_code,
  }: {
    code: string;
    country_code: string;
  }): Promise<IGetCart> => this.post(URLs.postCoupons, { code, country_code });
  deleteCoupons = (): Promise<IGetCart> => this.delete(URLs.deleteCoupons, {});
  submitCheckout = (body: any): Promise<ISubmitCheckoutResponse> => {
    const { fbc, fbp, fb_login_id, ttp, ttclid, twclid, ...rest } = body;
    const params: Record<string, any> = {};
    if (fbc) params.fbc = fbc;
    if (fbp) params.fbp = fbp;
    if (fb_login_id) params.fb_login_id = fb_login_id;
    if (ttp) params.ttp = ttp;
    if (ttclid) params.ttclid = ttclid;
    if (twclid) params.twclid = twclid;
    return this.post(
      URLs.submitCheckout,
      { ...rest },
      {
        params,
      },
    );
  };

  getPayments = (
    track_id: string,
    params?: {
      fbc?: string;
      fbp?: string;
      fb_login_id?: string;
      ttp?: string;
      ttclid?: string;
      twclid?: string;
    },
  ): Promise<IPaymentResponse> =>
    this.get(paymentURL + track_id, {
      params: params,
    });
  getPaymentMethods = (
    country_code: string,
    exchange_grand_total?: number,
    delivery_type?: string,
    track_id?: number | string,
  ): Promise<IGetPaymentMethods> => {
    console.log({track_id})
    return this.get(URLs.getPaymentMethods, {
      params: {
        ...(country_code ? { country_code } : {}),
        ...(exchange_grand_total != null ? { exchange_grand_total } : {}),
        ...(delivery_type ? { delivery_type } : {}),
        ...(track_id ? { track_id } : {}),
      },
    });
  };

  getDeliveryBranches = (
    address_id: number,
    area_id: number,
  ): Promise<IGetDeliveryBranches> =>
    this.get(URLs.getDeliveryBranches, { params: { address_id, area_id } });
  postPaymentMethodAvailable = (
    body: PostPaymentMethodAvailable,
  ): Promise<IPostPaymentMethodAvailableResult> =>
    this.post(URLs.postPaymentMethodAvailable, { ...body });

  refresh = ({ country_code }: { country_code: string }): Promise<IGetCart> =>
    this.post(URLs.refresh, { country_code });
}

export default ApiCart;

export const APIGetUserLocation = () =>
  axios
    .get("https://ipapi.co/json/")
    .then((response): UserLocation => response.data)
    .catch((_error) => {
      // console.error(error);
    });
